import { render, staticRenderFns } from "./AbaFiltro.vue?vue&type=template&id=1162a989&scoped=true"
import script from "./AbaFiltro.vue?vue&type=script&lang=js"
export * from "./AbaFiltro.vue?vue&type=script&lang=js"
import style0 from "./AbaFiltro.vue?vue&type=style&index=0&id=1162a989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1162a989",
  null
  
)

export default component.exports